module.exports = __webpack_public_path__ + "assets/img/NPC012.ee051801.png";